import * as yup from 'yup';
import { CookieBanner } from '@web/components';
import { linkSchema } from '../schemas';

export const component = CookieBanner;

const subpathSchema = yup.object({
  subpath: yup.string().required(),
});

export const schema = yup
  .object({
    heading: yup.string().required(),
    subheading: yup.string().required(),
    buttonCopy: yup.string(),
    buttonVariant: yup.string().nullable(),
    preLinkCopy: yup.string(),
    links: yup.array(linkSchema),
    excludedPaths: yup.array(subpathSchema),
  })
  .transform(value => ({
    heading: value.heading,
    subheading: value.subheading,
    buttonCopy: value.buttonCopy,
    buttonVariant: value.buttonVariant || undefined,
    preLinkCopy: value.preLinkCopy,
    links: value.links,
    excludedPaths: value.excludedPaths,
  }));
